<mat-dialog-content>
  @if (isAddTag) {
    <div>
      <mat-form-field appearance="fill">
        <mat-label>Add Item Tag</mat-label>
        <input matInput [(ngModel)]="name">
      </mat-form-field>
    </div>
  }
  @if (isAddAssetTag) {
    <div>
      <mat-form-field appearance="fill">
        <mat-label>Add Tag</mat-label>
        <input matInput [(ngModel)]="name">
      </mat-form-field>
    </div>
  }
  @if (!(isAddTag || isAddAssetTag)) {
    <p>
      {{message}}
    </p>
  }
</mat-dialog-content>
@if ((isAddTag || isAddAssetTag)) {
  <mat-dialog-actions align="center">
    <button mat-raised-button color="primary"  (click)="onConfirmClick(name)">{{confirmButtonText}}</button>
    <button mat-raised-button mat-dialog-close [mat-dialog-close]="false" >{{cancelButtonText}}</button>
  </mat-dialog-actions>
}
@if (!(isAddTag || isAddAssetTag)) {
  <mat-dialog-actions align="center">
    <button mat-raised-button color="primary"  (click)="onConfirmClick(true)">{{confirmButtonText}}</button>
    <button mat-raised-button mat-dialog-close [mat-dialog-close]="false" >{{cancelButtonText}}</button>
  </mat-dialog-actions>
}